module.exports = __webpack_public_path__ + "static/media/playSFX.3728b007.mp3";